module.exports = __webpack_public_path__ + "static/media/help.ea2aa90b.svg";